/**
 * User-visible APEX K9™ product strings (rebranded from "K9 Ops").
 * Use Unicode ™ in plain text (email, PDF, manifest JSON); use ApexK9TitleWithTm in React for superscript + a11y.
 */
export const APEX_K9_BRAND = 'APEX K9';

/** UTF-8 trademark sign (U+2122). Safe for HTML email and PDF footers. */
export const APEX_K9_BRAND_WITH_TM = 'APEX K9™';

/** Phrase for aria-label / screen readers */
export const APEX_K9_BRAND_ARIA_LABEL = 'APEX K9 trademark';

export const apexK9QuickMenuTitle = (): string => `${APEX_K9_BRAND_WITH_TM} Quick Menu`;

export const apexK9DashboardLoginDescription = (): string =>
  `You must be logged in to access the ${APEX_K9_BRAND_WITH_TM} Dashboard.`;

export const APEX_K9_DASHBOARD_HEADING_ARIA = 'APEX K9 trademark Dashboard';
